import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { FaHandPointRight } from 'react-icons/fa';
import { IoIosWarning } from 'react-icons/io';

import { PageRootWrapper } from '@/components/shared/PageRootWrapper';

export type Props = {
  intervalKey: 'password.reset' | 'activation';
  linkTo: string;
  errorCode: string | undefined;
};

export const TokenExpired: React.FC<Props> = ({
  intervalKey,
  linkTo,
  errorCode,
}) => {
  const { t } = useTranslation();
  const title = t(`pages.${intervalKey}.index.title`);

  return (
    <PageRootWrapper
      title={title}
      breadcrumbItems={[{ label: title }]}
      containerType="normal"
    >
      <Styled>
        <div className="warningCard" data-test="expired-error">
          <div className="signContainer">
            <IoIosWarning className="sign" />
          </div>
          <div>
            <div className="title">
              {t(`text.${intervalKey}.expired.warning`)}
            </div>
            <div>{t(`text.${intervalKey}.expired.description`)}</div>
          </div>
        </div>

        {errorCode !== 'already_activated' && (
          <div className="lead">
            <FaHandPointRight className="icon" />

            <div className="contents">
              <Link to={linkTo} className="title">
                {t(`text.${intervalKey}.expired.link`)}
              </Link>

              <div key={t(`text.${intervalKey}.expired.linkDescription`)}>
                {t(`text.${intervalKey}.expired.linkDescription`)}
              </div>
            </div>
          </div>
        )}
      </Styled>
    </PageRootWrapper>
  );
};

const Styled = styled.div`
  .warningCard {
    padding: 16px 24px;
    color: #9f3a38;
    background-color: #fff6f6;
    border-radius: 4px;
    border: 1px solid #e0b4b4;
    display: flex;
    margin-bottom: 44px;

    .signContainer {
      min-width: 82px;
      display: flex;
      align-items: center;
      .sign {
        width: 74.5px;
        height: 66px;
      }
    }
    .title {
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 4px;
    }
  }

  .lead {
    display: flex;
    padding-left: 28.5px;
    position: relative;

    .icon {
      position: absolute;
      left: 0;
    }

    .contents {
      display: flex;
      flex-direction: column;
      line-height: 18px;

      .title {
        color: #5281ff;
        font-weight: 700;
      }
    }
  }
`;
